import {Box, Pagination, Skeleton} from "@mui/material";
import React, {useEffect, useState} from "react";
import axios from "@helpers/axios/private.axios";
import {AnalyticsWrapper} from "./index";
import {FilterUsers} from "./components/FilterUsers";
import {UserItem} from "./components/UserItem";

export const ByUsers = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const getUsersAnalytics = async (page, data = {}) => {
    try {
      setLoading(true);

      const params = {
        page: page,
        ...data
      };
      
      const resp = await axios.get(`/users/analytics/by-user`, {params});
      if (Array.isArray(resp.data.data.analytics)) {
        setData(resp.data.data.analytics);
      } else {
        setData([]);
      }
      setLoading(false);
      setTotalPages(resp.data.pagination.total);
      setCurrentPage(page);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsersAnalytics(currentPage);
  }, [currentPage]);

  const changePage = (event, page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <AnalyticsWrapper>
        <FilterUsers loading={loading} setLoading={setLoading} filterCallback={getUsersAnalytics}/>
        <Box sx={{overflowX: "auto"}}>
          <Box sx={{minWidth: 1900}} className="table table--mini">
            <div className="table__tr table__tr--head">
              <Box
                sx={{
                  flex: "1 0 240px",
                }}
                className="table__td"
              >
                <div className="table__text">ID</div>
              </Box>
              <Box
                sx={{
                  flex: "1 0 120px",
                }}
                className="table__td"
              >
                <p className="table__text">Country</p>
              </Box>
              <Box
                sx={{
                  flex: "1 0 120px",
                }}
                className="table__td"
              >
                <p className="table__text">Fd sum</p>
              </Box>
              <Box
                sx={{
                  flex: "1 0 120px",
                }}
                className="table__td"
              >
                <p className="table__text">Fd date</p>
              </Box>
              <Box
                sx={{
                  flex: "1 0 120px",
                }}
                className="table__td"
              >
                <p className="table__text">Deposits count</p>
              </Box>
              <Box
                sx={{
                  flex: "1 0 120px",
                }}
                className="table__td"
              >
                <p className="table__text">Deposits sum</p>
              </Box>
              <Box
                sx={{
                  flex: "1 0 120px",
                }}
                className="table__td"
              >
                <p className="table__text">Withdrawals</p>
              </Box>
              <Box
                sx={{
                  flex: "1 0 85px",
                }}
                className="table__td"
              >
                <p className="table__text">Balance</p>
              </Box>
              <Box
                sx={{
                  flex: "1 0 120px",
                }}
                className="table__td"
              >
                <p className="table__text">Partner Profit</p>
              </Box>
              <Box
                sx={{
                  flex: "1 0 160px",
                }}
                className="table__td"
              >
                <p className="table__text">Link</p>
              </Box>
              {/*<Box*/}
              {/*  sx={{*/}
              {/*    flex: "1 0 120px",*/}
              {/*  }}*/}
              {/*  className="table__td"*/}
              {/*>*/}
              {/*  <p className="table__text">Profit</p>*/}
              {/*</Box>*/}
              <Box
                sx={{
                  flex: "1 0 120px",
                }}
                className="table__td"
              >
                <p className="table__text">Affiliate Link Offer</p>
              </Box>
              <Box
                sx={{
                  flex: "1 0 120px",
                }}
                className="table__td"
              >
                <p className="table__text">Campaign Name</p>
              </Box>
            </div>
            {loading ? <>
              <div className="table__tr">
                <Skeleton
                  className="table__skeleton"
                  variant="rounded"
                  width="100%"
                />
              </div>
              <div className="table__tr">
                <Skeleton
                  className="table__skeleton"
                  variant="rounded"
                  width="100%"
                />
              </div>
              <div className="table__tr">
                <Skeleton
                  className="table__skeleton"
                  variant="rounded"
                  width="100%"
                />
              </div>
            </> : data.length ? data.map((el) => <UserItem key={el.id} data={el}/>) :
              <div className="table__tr table__tr--head">
                <p>Not Found</p>
              </div>}
          </Box>
        </Box>
      </AnalyticsWrapper>
      {totalPages !== 1 && <Pagination
        className="pagination"
        count={totalPages}
        page={currentPage}
        onChange={changePage}
        variant="outlined"
        shape="rounded"
      />}
    </>)
}